// extracted by mini-css-extract-plugin
module.exports = {"fillWhite":"style_fillWhite__2FtHT","fillDark":"style_fillDark__DG0-j"};